import React from "react";
import SectionTitle from "../../components/Common/SectionTitle";
const FAQHeader = (data) => {
  let Description = data.data.description;
  return (
    <>
      <SectionTitle
        sectionClass="sec-title2 mb-30 text-center"
        subtitleClass="sub-text style-bg"
        subtitle="Marketing Experts"
        titleClass="title pb-25"
        title="FAQs"
        descClass="desc max-w-3xl mx-auto px-4 md:px-0 text-center"
        description={Description} 
        effectClass="heading-line"
      />
     
    </>
  );
};

export default FAQHeader;